import { useAddBasketHandler } from 'src/features/add-basket/hooks'
import {
    useChangeBasketItemCount,
    useDecrementBasketItemCount,
    useIncrementBasketItemCount
} from '@entities/basket/hooks'
import { useBasketGoodPositionCount } from '@entities/basket/model'
import { NumberChanger } from 'src/shared/ui/count-changer'
import Button from '@shared/Button/Button'
import { ElementSizeType } from '@styles/theme-const'
import React, { useCallback } from 'react'
import { ICatalogGoodBase } from '@entities/goods/contract'
import styled from 'styled-components'

export const ButtonBasketContainer = styled.div`
    font-size: 1rem;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    width: 140px;
    @media only screen and (max-width: 960px) {
        max-width: 100px;
    }
    height: 100%;
    & button {
        padding: 2px;
        height: 100%;
    }
`

export const ChangerGood = ({ children }: { children: ICatalogGoodBase }) => {
    const addBasket = useAddBasketHandler()
    const decrementBasketItemCount = useDecrementBasketItemCount()
    const incrementBasketItemCount = useIncrementBasketItemCount()
    const changeBasketItemCount = useChangeBasketItemCount()
    const count = useBasketGoodPositionCount(children.webData.goodId)
    const addBasketHandler = useCallback(() => {
        console.log('[ChangerGood] addBasketHandler updated')
        addBasket(children)
    }, [addBasket, children])
    return (
        <ButtonBasketContainer>
            {count ? (
                <NumberChanger
                    value={count}
                    decrement={() => decrementBasketItemCount(children.webData.goodId)}
                    increment={() => incrementBasketItemCount(children.webData.goodId)}
                    changeNumber={(cn) => changeBasketItemCount({ goodId: children.webData.goodId, count: cn })}
                />
            ) : (
                <Button
                    data-basket-button-good-id={children.webData.goodId}
                    elementSizeTypeValue={ElementSizeType.regular}
                    clickHandler={addBasketHandler}>
                    В корзину
                </Button>
            )}
        </ButtonBasketContainer>
    )
}
